class BundleBuilder {
  constructor() {
    // Translations can be customized here
    this.translations = {
      // Cart messages
      emptyCartMessage: 'Aggiungi un prodotto per iniziare!',
      addToBundle: 'AGGIUNGI',
      viewBundle: 'PROSEGUI ',
      addBundleToCart: 'ACQUISTA ORA',
      addingToCart: 'CARICO...',
      
      // Discount messages
      discountTier1Message: 'Aggiungi 1 per il 20% di sconto',
      discountTier2Message: 'Aggiungi 1 per il 30% di sconto',
      discountTier3Message: 'Aggiungi 1 per il 40% di sconto',
      discountMaxMessage: '40% di sconto + Dieta Omaggio!',
      
      // Shipping messages
      shippingText: 'SPEDIZIONE:',
      shippingCalculating: 'CALCOLO...',
      shippingFree: 'GRATIS',
      
      // Checkout and pricing
      subtotalText: 'TOTALE:',
      itemsText: 'prodotto',
      viewBundleButton: 'PROSEGUI',
      
      // Error messages
      cartErrorMessage: 'Sorry, there was an error adding your bundle to cart. Please try again.'
    };
    
    this.bundleItems = [];
    this.bundleCart = document.querySelector('[data-bundle-cart]');
    this.bundleCartItems = document.querySelector('[data-bundle-cart-items]');
    this.bundleCartCount = document.querySelector('[data-bundle-cart-count]');
    this.bundleSubtotal = document.querySelector('[data-bundle-subtotal]');
    this.bundleShipping = document.querySelector('[data-bundle-shipping]');
    this.bundleCheckoutBtn = document.querySelector('[data-bundle-checkout]');
    this.addToCartButtons = document.querySelectorAll('.bundle-product-card__add-btn');
    this.productCards = document.querySelectorAll('.bundle-product-card');
    this.variantSelectors = document.querySelectorAll('[data-variant-select]');
    
    // Get free gift product data from section settings
    const freeGiftProductData = document.querySelector('[data-free-gift-product]');
    this.freeGiftProduct = freeGiftProductData ? JSON.parse(freeGiftProductData.textContent) : null;
    
    // Mobile elements
    this.mobileCartDrawer = document.querySelector('[data-bundle-mobile-cart]');
    this.mobileCartOverlay = document.querySelector('[data-bundle-mobile-cart-overlay]');
    this.mobileCartClose = document.querySelector('[data-bundle-mobile-cart-close]');
    this.mobileCartBody = this.mobileCartDrawer ? this.mobileCartDrawer.querySelector('.bundle-mobile-cart-drawer__body') : null;
    this.mobileCartBar = document.querySelector('[data-bundle-mobile-cart-bar]');
    this.mobileCartToggle = document.querySelector('[data-bundle-mobile-cart-toggle]');
    this.mobileCartCount = document.querySelector('[data-bundle-mobile-cart-count]');
    this.mobileCartSubtotal = document.querySelector('[data-bundle-mobile-cart-subtotal]');
    
    this.discountTiers = [
      { minItems: 4, discount: 0.4 }, // 40% off for 4+ items
      { minItems: 3, discount: 0.3 }, // 30% off for 3 items
      { minItems: 2, discount: 0.2 }  // 20% off for 2 items
    ];
    
    // Discount code configurations for checkout
    this.discountCodes = {
      tier1: 'WB2520', // 20% discount code for 2 items
      tier2: 'WB2530', // 30% discount code for 3 items
      tier3: 'WB2540',  // 40% discount code for 4+ items
      freeGift: 'WB25FD'
    };
    
    this.freeShippingThreshold = 6500; // €49.99
    this.standardShippingCost = 690; // €4.99
    this.storageKey = 'bundleBuilder_savedItems';
    this.isMobile = window.innerWidth < 992;
    
    // Modal elements
    this.productModal = document.querySelector('[data-bundle-product-modal]');
    this.productModalOverlay = document.querySelector('[data-bundle-product-modal-overlay]');
    this.productModalClose = document.querySelector('[data-bundle-product-modal-close]');
    this.productModalImage = document.querySelector('[data-bundle-product-modal-image]');
    this.productModalTitle = document.querySelector('[data-bundle-product-modal-title]');
    this.productModalVariant = document.querySelector('[data-bundle-product-modal-variant]');
    this.productModalPrice = document.querySelector('[data-bundle-product-modal-price]');
    this.productModalDescription = document.querySelector('[data-bundle-product-modal-description]');
    this.productModalAddBtn = document.querySelector('[data-bundle-product-modal-add-btn]');
    
    this.init();
  }

  init() {
    // Listen for window resize to update mobile state
    window.addEventListener('resize', this.handleResize.bind(this));
    
    // Try to restore saved bundle first
    this.restoreSavedBundle();
    
    // Add original prices as data attributes for reference
    this.addToCartButtons.forEach(button => {
      const productId = button.dataset.productId;
      const productPrice = parseFloat(button.dataset.productPrice);
      const productCard = button.closest('.bundle-product-card');
      if (productCard) {
        productCard.dataset.originalPrice = productPrice;
      }
    });
    
    // Initialize event listeners
    this.addEventListeners();
    
    // Initialize product buttons and prices after bundle items have been restored
    if (this.bundleItems.length > 0) {
      console.log('Initializing bundle with saved items:', this.bundleItems.length);
    }
    
    // Update UI with current bundle state
    this.updateCart();
    this.updateProductPrices();
    this.updateProductButtons();
    this.updateMobileCart();

    // Initialize Judge.me reviews if available
    this.initJudgeMe();
    
    // Initialize modal event listeners
    this.initModalEventListeners();
  }
  
  handleResize() {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth < 992;
    
    // If switching between mobile and desktop, update the UI
    if (wasMobile !== this.isMobile) {
      this.updateMobileCart();
    }
  }

  restoreSavedBundle() {
    try {
      const savedBundle = localStorage.getItem(this.storageKey);
      if (savedBundle) {
        const parsedBundle = JSON.parse(savedBundle);
        if (Array.isArray(parsedBundle) && parsedBundle.length > 0) {
          // Get available product IDs on the page
          const availableProductIds = Array.from(this.addToCartButtons).map(button => button.dataset.productId);
          
          // Filter bundle items to only include products that are available on the current page
          this.bundleItems = parsedBundle.filter(item => {
            const isValid = item && item.id && item.title && item.price && item.image && item.quantity;
            // Allow free gift items to pass through without checking availability
            const isAvailable = item.isFreeGift ? true : availableProductIds.includes(item.id);
            return isValid && isAvailable;
          });
          
          // After restoring items, check if we need to add the free gift
          this.manageFreeGift();
        }
      }
    } catch (error) {
      console.error('Error restoring saved bundle:', error);
      localStorage.removeItem(this.storageKey);
      this.bundleItems = [];
    }
  }

  saveBundle() {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(this.bundleItems));
    } catch (error) {
      console.error('Error saving bundle:', error);
    }
  }

  clearSavedBundle() {
    localStorage.removeItem(this.storageKey);
  }

  initJudgeMe() {
    // If Judge.me is already loaded, refresh the badges
    if (typeof window.jdgm !== 'undefined' && window.jdgm.customizeBadges) {
      window.jdgm.customizeBadges();
    }
  }

  addEventListeners() {
    // Add event listeners to product buttons
    this.addToCartButtons.forEach(button => {
      button.addEventListener('click', this.handleAddToBundle.bind(this));
    });

    // Add event listener to checkout button
    if (this.bundleCheckoutBtn) {
      this.bundleCheckoutBtn.addEventListener('click', this.addBundleToCart.bind(this));
    }
    
    // Add event listeners to variant selectors
    this.variantSelectors.forEach(select => {
      select.addEventListener('change', this.handleVariantChange.bind(this));
    });
    
    // Mobile cart drawer event listeners
    if (this.mobileCartOverlay) {
      this.mobileCartOverlay.addEventListener('click', this.closeMobileCart.bind(this));
    }
    
    if (this.mobileCartClose) {
      this.mobileCartClose.addEventListener('click', this.closeMobileCart.bind(this));
    }
    
    if (this.mobileCartToggle) {
      this.mobileCartToggle.addEventListener('click', this.openMobileCart.bind(this));
    }
  }
  
  handleVariantChange(event) {
    const select = event.currentTarget;
    const selectedOption = select.options[select.selectedIndex];
    const productId = select.dataset.productId;
    const variantId = selectedOption.dataset.variantId;
    const variantPrice = selectedOption.dataset.variantPrice;
    const variantImageId = selectedOption.dataset.variantImageId;
    const variantImage = selectedOption.dataset.variantImage;
    const variantTitle = selectedOption.textContent.trim();
    
    // Find the product card container
    const productCard = select.closest('.bundle-product-item');
    if (!productCard) return;
    
    // Update the price display
    const priceElement = productCard.querySelector('.bundle-product-card__price');
    if (priceElement) {
      priceElement.dataset.productPrice = variantPrice;
      
      // Apply any active discount
      const discount = this.getCurrentDiscount();
      if (discount > 0) {
        const discountedPrice = variantPrice * (1 - discount);
        priceElement.innerHTML = `
          <span class="bundle-product-card__original-price">${this.formatMoney(variantPrice)}</span>
          <span class="bundle-product-card__discounted-price">${this.formatMoney(discountedPrice)}</span>
          <span class="bundle-product-card__discount-tag">${this.getDiscountPercentText()}</span>
        `;
      } else {
        priceElement.innerHTML = this.formatMoney(variantPrice);
      }
    }
    
    // Update the add to bundle button
    const addButton = productCard.querySelector('.bundle-product-card__add-btn');
    if (addButton) {
      addButton.dataset.productId = variantId;
      addButton.dataset.productPrice = variantPrice;
      addButton.dataset.productImage = variantImage;
      addButton.dataset.variantTitle = variantTitle;
      
      // Check if this variant is in the cart and update button state
      const existingItem = this.bundleItems.find(item => item.id === variantId);
      
      if (existingItem) {
        // If this variant is in the cart, update the button to show quantity
        addButton.classList.add('in-bundle');
        addButton.innerHTML = `
          <div class="bundle-quantity-selector">
            <button class="bundle-quantity-btn bundle-quantity-decrease" data-action="decrease">-</button>
            <span class="bundle-quantity-num">${existingItem.quantity}</span>
            <button class="bundle-quantity-btn bundle-quantity-increase" data-action="increase">+</button>
          </div>
        `;
        
        // Add event listeners for the quantity buttons
        const decreaseBtn = addButton.querySelector('.bundle-quantity-decrease');
        const increaseBtn = addButton.querySelector('.bundle-quantity-increase');
        
        if (decreaseBtn) {
          decreaseBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.updateQuantity(variantId, existingItem.quantity - 1);
          });
        }
        
        if (increaseBtn) {
          increaseBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.updateQuantity(variantId, existingItem.quantity + 1);
          });
        }
        
        // Disable the main button click when in quantity selector mode
        addButton.onclick = (e) => e.stopPropagation();
      } else {
        // If this variant is not in the cart, show "Add to Bundle" button
        addButton.classList.remove('in-bundle');
        addButton.innerHTML = this.translations.addToBundle;
        
        // Re-enable the main button click
        addButton.onclick = this.handleAddToBundle.bind(this);
      }
    }
    
    // Update the product image if needed
    const productImage = productCard.querySelector('.bundle-product-card__primary-image');
    if (productImage) {
      // Look for the variant image in the hidden container
      const variantImagesContainer = productCard.querySelector('.bundle-product-variant-images');
      if (variantImagesContainer) {
        const variantImageElement = variantImagesContainer.querySelector(`[data-variant-id="${variantId}"]`);
        if (variantImageElement) {
          productImage.src = variantImageElement.src;
          productImage.alt = variantImageElement.alt;
        }
      }
    }
  }
  
  openMobileCart() {
    if (this.mobileCartDrawer) {
      this.mobileCartDrawer.classList.add('is-active');
      document.body.style.overflow = 'hidden'; // Prevent scrolling when drawer is open
      
      // Update mobile cart content
      this.syncMobileCartContent();
    }
  }
  
  closeMobileCart() {
    if (this.mobileCartDrawer) {
      this.mobileCartDrawer.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  }
  
  syncMobileCartContent() {
    if (!this.mobileCartBody || !this.bundleCart) return;
    
    // Clone the cart content for the mobile drawer
    const cartContent = this.bundleCart.querySelector('.bundle-cart__content');
    const cartFooter = this.bundleCart.querySelector('.bundle-cart__footer');
    
    if (cartContent && cartFooter) {
      // Clear mobile cart body
      this.mobileCartBody.innerHTML = '';
      
      // Clone content section (with items) and append to mobile cart
      const contentClone = cartContent.cloneNode(true);
      this.mobileCartBody.appendChild(contentClone);
      
      // Clone footer section and append to mobile cart
      const footerClone = cartFooter.cloneNode(true);
      this.mobileCartBody.appendChild(footerClone);
      
      // Re-attach event listeners to remove buttons in the cloned content
      const removeButtons = this.mobileCartBody.querySelectorAll('[data-action="remove"]');
      removeButtons.forEach(button => {
        const itemId = button.closest('[data-item-id]').dataset.itemId;
        button.addEventListener('click', () => this.removeFromBundle(itemId));
      });
      
      // Re-attach event listeners to quantity selectors in the cloned content
      const quantitySelectors = this.mobileCartBody.querySelectorAll('.bundle-quantity-selector');
      quantitySelectors.forEach(selector => {
        const itemId = selector.closest('[data-item-id]')?.dataset.itemId;
        if (itemId) {
          const decreaseBtn = selector.querySelector('.bundle-quantity-decrease');
          const increaseBtn = selector.querySelector('.bundle-quantity-increase');
          
          if (decreaseBtn) {
            decreaseBtn.addEventListener('click', (e) => {
              e.stopPropagation();
              const item = this.bundleItems.find(item => item.id === itemId);
              if (item) this.updateQuantity(itemId, item.quantity - 1);
            });
          }
          
          if (increaseBtn) {
            increaseBtn.addEventListener('click', (e) => {
              e.stopPropagation();
              const item = this.bundleItems.find(item => item.id === itemId);
              if (item) this.updateQuantity(itemId, item.quantity + 1);
            });
          }
        }
      });
      
      // Re-attach event listener to checkout button
      const checkoutBtn = this.mobileCartBody.querySelector('[data-bundle-checkout]');
      if (checkoutBtn) {
        checkoutBtn.addEventListener('click', this.addBundleToCart.bind(this));
      }
      
      // Update the cart header with discount info
      this.updateCartHeader();
    }
  }
  
  updateMobileCart() {
    if (!this.isMobile) {
      // Hide mobile elements on desktop
      if (this.mobileCartBar) {
        this.mobileCartBar.classList.remove('is-active');
      }
      if (this.mobileCartDrawer) {
        this.mobileCartDrawer.classList.remove('is-active');
      }
      return;
    }
    
    // Update mobile cart bar
    if (this.mobileCartBar) {
      const hasItems = this.bundleItems.length > 0;
      
      if (hasItems) {
        this.mobileCartBar.classList.add('is-active');
        
        // Get discount and subtotal information
        const discount = this.getCurrentDiscount();
        const originalSubtotal = this.bundleItems.reduce((total, item) => total + (item.price * item.quantity), 0);
        const discountedSubtotal = discount > 0 ? originalSubtotal * (1 - discount) : originalSubtotal;
        
        // Update price display in the bar with original price, discounted price and percentage
        if (this.mobileCartCount && this.mobileCartSubtotal) {
          if (discount > 0) {
            // If there's a discount, show original price, discounted price and discount percentage
            const discountPercentText = `-${(discount * 100).toFixed(0)}%`;
            
            this.mobileCartCount.innerHTML = `<span class="bundle-mobile-cart-bar__original-price">${this.formatMoney(originalSubtotal)}</span>`;
            this.mobileCartSubtotal.innerHTML = `
              <span class="bundle-mobile-cart-bar__discounted-price">${this.formatMoney(discountedSubtotal)}</span>
              <span class="bundle-mobile-cart-bar__discount-percent">${discountPercentText}</span>
            `;
          } else {
            // If no discount, just show the subtotal
            const totalItems = this.bundleItems.reduce((total, item) => total + item.quantity, 0);
            this.mobileCartCount.textContent = `${totalItems} ${this.translations.itemsText}`;
            this.mobileCartSubtotal.textContent = this.formatMoney(originalSubtotal);
          }
        }
        
        // Update the toggle button text
        if (this.mobileCartToggle) {
          this.mobileCartToggle.textContent = this.translations.viewBundleButton;
        }
      } else {
        // Hide cart bar if no items
        this.mobileCartBar.classList.remove('is-active');
        this.closeMobileCart();
      }
    }
    
    // Make sure mobile cart content is up to date
    this.syncMobileCartContent();
  }

  handleAddToBundle(event) {
    const button = event.currentTarget;
    const productId = button.dataset.productId;
    const productTitle = button.dataset.productTitle;
    const productPrice = parseFloat(button.dataset.productPrice);
    const productImage = button.dataset.productImage;
    const variantTitle = button.dataset.variantTitle || '';
    
    // Check if product already exists in bundle
    const existingItem = this.bundleItems.find(item => item.id === productId);
    
    if (existingItem) {
      existingItem.quantity += 1;
    } else {
      // Add the selected product to the bundle
      this.bundleItems.push({
        id: productId,
        title: productTitle,
        price: productPrice,
        image: productImage,
        variantTitle: variantTitle,
        quantity: 1
      });
    }
    
    // Check if we need to add the free gift
    this.manageFreeGift();
    
    // Update the UI
    this.updateCart();
    this.updateProductPrices();
    this.updateProductButtons();
    this.updateMobileCart();
    this.saveBundle();
  }

  removeFromBundle(productId) {
    // Remove the item
    this.bundleItems = this.bundleItems.filter(item => item.id !== productId);
    
    // Check if we need to remove the free gift
    this.manageFreeGift();
    
    this.updateCart();
    this.updateProductPrices();
    this.updateProductButtons();
    this.updateMobileCart();
    this.saveBundle();
  }

  updateQuantity(productId, quantity) {
    const item = this.bundleItems.find(item => item.id === productId);
    if (item) {
      if (quantity < 1) {
        // Remove item completely if quantity becomes zero
        this.removeFromBundle(productId);
      } else {
        item.quantity = quantity;
        // Check if we need to add/remove the free gift
        this.manageFreeGift();
        this.updateCart();
        this.updateProductPrices();
        this.updateProductButtons();
        this.updateMobileCart();
        this.saveBundle();
      }
    }
  }

  manageFreeGift() {
    // Calculate total items (including quantities)
    const totalItems = this.bundleItems.reduce((total, item) => {
      // Don't count the free gift in the total
      if (item.isFreeGift) return total;
      return total + item.quantity;
    }, 0);
    
    // Find if free gift is already in the bundle
    const freeGiftIndex = this.bundleItems.findIndex(item => item.isFreeGift);
    
    if (totalItems >= 4 && this.freeGiftProduct) {
      // If we have 4 or more items and no free gift, add it
      if (freeGiftIndex === -1) {
        this.bundleItems.push({
          id: this.freeGiftProduct.variant_id,
          title: this.freeGiftProduct.title,
          price: 6000, // Set original price to 6000
          image: this.freeGiftProduct.image,
          variantTitle: this.freeGiftProduct.variant_title || '',
          quantity: 1,
          isFreeGift: true
        });
      }
    } else if (freeGiftIndex !== -1) {
      // If we have less than 4 items and the free gift is present, remove it
      this.bundleItems.splice(freeGiftIndex, 1);
    }
  }

  updateCart() {
    this.renderCartItems();
    this.updateCartCount();
    this.updateSubtotal();
    this.updateShipping();
    this.updateCartHeader();
  }

  updateCartHeader() {
    const discount = this.getCurrentDiscount();
    
    // Update desktop cart header
    const desktopHeader = document.querySelector('.bundle-cart__header');
    if (desktopHeader) {
      // Remove existing discount banner if any
      const existingBanner = desktopHeader.querySelector('.bundle-cart__header-discount');
      if (existingBanner) {
        existingBanner.remove();
      }
      
      // Add discount banner if there's an active discount
      if (discount > 0) {
        const discountBanner = document.createElement('div');
        discountBanner.className = 'bundle-cart__header-discount';
        discountBanner.innerHTML = `${this.getDiscountPercentText()} di sconto applicato!`;
        desktopHeader.appendChild(discountBanner);
      }
    }
    
    // Update mobile cart header
    const mobileHeader = document.querySelector('.bundle-mobile-cart-drawer__header');
    if (mobileHeader) {
      // Remove existing discount banner if any
      const existingBanner = mobileHeader.querySelector('.bundle-cart__header-discount');
      if (existingBanner) {
        existingBanner.remove();
      }
      
      // Add discount banner if there's an active discount
      if (discount > 0) {
        const discountBanner = document.createElement('div');
        discountBanner.className = 'bundle-cart__header-discount';
        discountBanner.innerHTML = `${this.getDiscountPercentText()} di sconto applicato!`;
        mobileHeader.appendChild(discountBanner);
      }
    }
  }

  getCurrentDiscount() {
    // Count total items including duplicates
    const totalItemCount = this.bundleItems.reduce((total, item) => total + item.quantity, 0);
    
    for (const tier of this.discountTiers) {
      if (totalItemCount >= tier.minItems) {
        return tier.discount;
      }
    }
    
    return 0; // No discount if less than 2 items
  }

  getDiscountedPrice(originalPrice) {
    const discount = this.getCurrentDiscount();
    return originalPrice * (1 - discount);
  }

  getDiscountPercentText() {
    const discount = this.getCurrentDiscount();
    if (discount <= 0) return '';
    
    return `-${(discount * 100).toFixed(0)}%`;
  }

  updateProductPrices() {
    const discount = this.getCurrentDiscount();
    const allProductCards = document.querySelectorAll('.bundle-product-card');
    
    allProductCards.forEach(card => {
      const originalPrice = parseFloat(card.dataset.originalPrice);
      const priceElement = card.querySelector('.bundle-product-card__price');
      
      if (priceElement && originalPrice) {
        if (discount > 0) {
          const discountedPrice = this.getDiscountedPrice(originalPrice);
          priceElement.innerHTML = `
            <span class="bundle-product-card__original-price">${this.formatMoney(originalPrice)}</span>
            <span class="bundle-product-card__discounted-price">${this.formatMoney(discountedPrice)}</span>
            <span class="bundle-product-card__discount-tag">${this.getDiscountPercentText()}</span>
          `;
          card.classList.add('has-discount');
        } else {
          priceElement.innerHTML = this.formatMoney(originalPrice);
          card.classList.remove('has-discount');
        }
      }
    });
  }

  updateProductButtons() {
    // Update all product buttons based on cart contents
    const allButtons = document.querySelectorAll('.bundle-product-card__add-btn');
    
    allButtons.forEach(button => {
      const productId = button.dataset.productId;
      const productItem = this.bundleItems.find(item => item.id === productId);
      const productCard = button.closest('.bundle-product-card');
      
      if (productItem) {
        // Product is in cart, show quantity selector
        button.classList.add('in-bundle');
        button.innerHTML = `
          <div class="bundle-quantity-selector">
            <button class="bundle-quantity-btn bundle-quantity-decrease" data-action="decrease">-</button>
            <span class="bundle-quantity-num">${productItem.quantity}</span>
            <button class="bundle-quantity-btn bundle-quantity-increase" data-action="increase">+</button>
          </div>
        `;
        
        // Add event listeners for the new buttons
        const decreaseBtn = button.querySelector('.bundle-quantity-decrease');
        const increaseBtn = button.querySelector('.bundle-quantity-increase');
        
        // Remove any existing event listeners
        if (decreaseBtn) {
          const newDecreaseBtn = decreaseBtn.cloneNode(true);
          decreaseBtn.parentNode.replaceChild(newDecreaseBtn, decreaseBtn);
          newDecreaseBtn.addEventListener('click', (e) => {
            e.stopPropagation(); // Prevent triggering the main button click
            this.updateQuantity(productId, productItem.quantity - 1);
          });
        }
        
        if (increaseBtn) {
          const newIncreaseBtn = increaseBtn.cloneNode(true);
          increaseBtn.parentNode.replaceChild(newIncreaseBtn, increaseBtn);
          newIncreaseBtn.addEventListener('click', (e) => {
            e.stopPropagation(); // Prevent triggering the main button click
            this.updateQuantity(productId, productItem.quantity + 1);
          });
        }
        
        // Disable the main button click when in quantity selector mode
        button.onclick = (e) => e.stopPropagation();
        
        if (productCard) {
          productCard.classList.add('in-bundle');
        }
      } else {
        // Product is not in cart, show "Add to Bundle" button
        button.classList.remove('in-bundle');
        button.innerHTML = this.translations.addToBundle;
        
        // Re-enable the main button click
        button.onclick = null;
        
        if (productCard) {
          productCard.classList.remove('in-bundle');
        }
      }
    });
  }

  renderCartItems() {
    if (!this.bundleCartItems) return;

    this.bundleCartItems.innerHTML = '';

    if (this.bundleItems.length === 0) {
      const emptyMessage = document.createElement('div');
      emptyMessage.className = 'bundle-cart__empty-message';
      emptyMessage.textContent = this.translations.emptyCartMessage;
      this.bundleCartItems.appendChild(emptyMessage);
      return;
    }

    this.bundleItems.forEach(item => {
      const itemElement = document.createElement('div');
      itemElement.className = 'bundle-cart-item';
      itemElement.dataset.itemId = item.id;

      const originalItemPrice = item.price;
      const discountedItemPrice = item.isFreeGift ? 0 : this.getDiscountedPrice(originalItemPrice);
      const currentDiscount = item.isFreeGift ? 1 : this.getCurrentDiscount(); // 100% discount for free gift
      
      // Add variant title if available
      let fullTitle = item.title;
      
      // Add variant title if available
      if (item.variantTitle) {
        fullTitle += ` <span class="bundle-cart-item__variant-title">(${item.variantTitle})</span>`;
      }
      
      // Add quantity badge if more than 1
      const titleWithQuantity = item.quantity > 1 ? 
        `${fullTitle} <span class="bundle-cart-item__quantity-badge">x${item.quantity}</span>` : 
        fullTitle;

      // Show the price per item, not total
      const priceHtml = currentDiscount > 0
        ? `<div class="bundle-cart-item__price">
             <span class="bundle-cart-item__original-price">${this.formatMoney(originalItemPrice)}</span>
             <span class="bundle-cart-item__discounted-price">${this.formatMoney(discountedItemPrice)}</span>
             <span class="bundle-cart-item__discount-percent">${item.isFreeGift ? '-100%' : this.getDiscountPercentText()}</span>
           </div>`
        : `<div class="bundle-cart-item__price">${this.formatMoney(originalItemPrice)}</div>`;

      // Try to load Judge.me badge for this product from the page
      const productCard = document.querySelector(`.bundle-product-item[data-product-id="${item.id}"]`);
      let judgeMeBadge = '';
      
      if (productCard) {
        const badgeElement = productCard.querySelector('.jdgm-preview-badge');
        if (badgeElement) {
          judgeMeBadge = `<div class="bundle-cart-item__reviews">${badgeElement.outerHTML}</div>`;
        }
      }

      itemElement.innerHTML = `
        <div class="bundle-cart-item__image">
          <img src="${item.image}" alt="${item.title}">
        </div>
        <div class="bundle-cart-item__content">
          <div class="bundle-cart-item__title">${titleWithQuantity}</div>
          ${judgeMeBadge}
          ${priceHtml}
        </div>
        <button class="bundle-cart-item__remove" data-action="remove">&times;</button>
      `;

      // Add event listener for remove button only
      const removeBtn = itemElement.querySelector('[data-action="remove"]');
      removeBtn.addEventListener('click', () => this.removeFromBundle(item.id));

      this.bundleCartItems.appendChild(itemElement);
    });
  }

  updateCartCount() {
    if (!this.bundleCartCount) return;
    
    const totalItems = this.bundleItems.reduce((total, item) => total + item.quantity, 0);
    this.bundleCartCount.textContent = totalItems;

    if (totalItems > 0) {
      this.bundleCartCount.classList.add('has-items');
    } else {
      this.bundleCartCount.classList.remove('has-items');
    }
  }

  updateSubtotal() {
    if (!this.bundleSubtotal) return;
    
    const discount = this.getCurrentDiscount();
    const originalSubtotal = this.bundleItems.reduce((total, item) => {
      // For free gift, use 0 as the final price
      if (item.isFreeGift) return total;
      return total + (item.price * item.quantity);
    }, 0);
    const discountedSubtotal = discount > 0 ? originalSubtotal * (1 - discount) : originalSubtotal;
    
    // Update the subtotal display
    let subtotalHtml = '';
    if (discount > 0) {
      subtotalHtml = `
        <span class="bundle-cart__subtotal-original">${this.formatMoney(originalSubtotal)}</span>
        <span class="bundle-cart__subtotal-discounted">${this.formatMoney(discountedSubtotal)}</span>
      `;
    } else {
      subtotalHtml = this.formatMoney(originalSubtotal);
    }
    
    this.bundleSubtotal.innerHTML = subtotalHtml;
  }

  updateShipping() {
    if (!this.bundleShipping) return;
    
    const shippingEl = this.bundleShipping.querySelector('.bundle-cart__shipping-price');
    if (!shippingEl) return;
    
    // If no items in bundle, show "Calculating..."
    if (this.bundleItems.length === 0) {
      shippingEl.textContent = this.translations.shippingCalculating;
      shippingEl.className = 'bundle-cart__shipping-price';
      return;
    }
    
    // Get the discounted subtotal
    const discount = this.getCurrentDiscount();
    const originalSubtotal = this.bundleItems.reduce((total, item) => total + (item.price * item.quantity), 0);
    const discountedSubtotal = discount > 0 ? originalSubtotal * (1 - discount) : originalSubtotal;
    
    // Free shipping over threshold
    if (discountedSubtotal >= this.freeShippingThreshold) {
      shippingEl.textContent = this.translations.shippingFree;
      shippingEl.className = 'bundle-cart__shipping-price bundle-cart__shipping-price--free';
    } else {
      // Show standard shipping cost
      shippingEl.textContent = this.formatMoney(this.standardShippingCost);
      shippingEl.className = 'bundle-cart__shipping-price bundle-cart__shipping-price--paid';
    }
  }

  formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    
    // Fallback money formatter if Shopify.formatMoney is not available - use EUR
    return (cents / 100).toFixed(2) + ' €';
  }

  async addBundleToCart() {
    if (this.bundleItems.length === 0) return;

    try {
      const bundleGroupId = 'bundle-' + Date.now();
      
      // Add loading state
      const checkoutBtns = document.querySelectorAll('[data-bundle-checkout]');
      checkoutBtns.forEach(btn => {
        btn.classList.add('is-loading');
        btn.textContent = this.translations.addingToCart;
      });

      // Clear the cart first
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      // Calculate total items (excluding free gift)
      const totalItems = this.bundleItems.reduce((total, item) => {
        if (item.isFreeGift) return total;
        return total + item.quantity;
      }, 0);

      // Prepare items for cart
      const cartItems = this.bundleItems.map(item => {
        const properties = {
          'Bundle Discount': this.getDiscountPercentText(),
          '_Bundle Group': bundleGroupId
        };
        
        if (item.variantTitle) {
          properties['_Variant'] = item.variantTitle;
        }

        // Add free gift property if applicable
        if (item.isFreeGift) {
          properties['_Free Gift'] = 'Yes';
        }
        
        return {
          id: item.id,
          quantity: item.quantity,
          properties: properties
        };
      });

      // If we have 4+ items and free gift product exists but isn't in the bundle, add it
      if (totalItems >= 4 && this.freeGiftProduct && !this.bundleItems.some(item => item.isFreeGift)) {
        cartItems.push({
          id: this.freeGiftProduct.variant_id,
          quantity: 1,
          properties: {
            'Bundle Discount': this.getDiscountPercentText(),
            '_Bundle Group': bundleGroupId,
            '_Free Gift': 'Yes'
          }
        });
      }

      const formData = { items: cartItems };

      // Add items to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error('Failed to add items to cart');
      }

      // Clear the saved bundle
      this.clearSavedBundle();
      
        // Get appropriate discount code(s) based on number of items in bundle
      const totalItemCount = this.bundleItems.reduce((total, item) => total + item.quantity, 0);
      let discountCodes = [];

      if (totalItemCount >= 4) {
        // Apply both 40% discount and free gift discount
        discountCodes.push(this.discountCodes.tier3);
        
        // Add the free gift discount code if you have one
        // Replace 'YOUR_FREE_GIFT_CODE' with your actual free gift discount code
        if (this.discountCodes.freeGift) {
          discountCodes.push(this.discountCodes.freeGift);
        }
      } else if (totalItemCount === 3) {
        discountCodes.push(this.discountCodes.tier2);
      } else if (totalItemCount === 2) {
        discountCodes.push(this.discountCodes.tier1);
      }

      // Redirect to checkout with discount code(s) if applicable
      if (discountCodes.length > 0) {
        // Join multiple discount codes with comma
        window.location.href = `/checkout?discount=${discountCodes.join(',')}`;
      } else {
        window.location.href = '/checkout';
      }
    } catch (error) {
      console.error('Error adding bundle to cart:', error);
      alert(this.translations.cartErrorMessage);
    } finally {
      const checkoutBtns = document.querySelectorAll('[data-bundle-checkout]');
      checkoutBtns.forEach(btn => {
        btn.classList.remove('is-loading');
        btn.textContent = this.translations.addBundleToCart;
      });
    }
  }

  initModalEventListeners() {
    // Close modal when clicking overlay or close button
    if (this.productModalOverlay) {
      this.productModalOverlay.addEventListener('click', this.closeProductModal.bind(this));
    }
    
    if (this.productModalClose) {
      this.productModalClose.addEventListener('click', this.closeProductModal.bind(this));
    }
    
    // Add click handlers to product images and titles
    this.productCards.forEach(card => {
      const image = card.querySelector('.bundle-product-card__image');
      const title = card.querySelector('.bundle-product-card__title');
      const btn = card.querySelector('.bundle-product-card__info-btn');
      
      if (image) {
        image.addEventListener('click', (e) => {
          e.preventDefault();
          this.openProductModal(card);
        });
      }

      if (btn) {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.openProductModal(card);
        });
      }
      
      if (title) {
        title.addEventListener('click', (e) => {
          e.preventDefault();
          this.openProductModal(card);
        });
      }
    });

    // Add click handler for modal Add to Bundle button
    if (this.productModalAddBtn) {
      this.productModalAddBtn.addEventListener('click', () => {
        const productId = this.productModalAddBtn.dataset.productId;
        if (productId) {
          // Create a synthetic event object with the current product data
          const syntheticEvent = {
            currentTarget: {
              dataset: {
                productId: this.productModalAddBtn.dataset.productId,
                productTitle: this.productModalAddBtn.dataset.productTitle,
                productPrice: this.productModalAddBtn.dataset.productPrice,
                productImage: this.productModalAddBtn.dataset.productImage,
                variantTitle: this.productModalAddBtn.dataset.variantTitle
              }
            }
          };
          this.handleAddToBundle(syntheticEvent);
          this.closeProductModal();
        }
      });
    }
  }

  openProductModal(productCard) {
    if (!this.productModal) return;
    
    const addButton = productCard.querySelector('.bundle-product-card__add-btn');
    const productId = addButton.dataset.productId;
    const productTitle = addButton.dataset.productTitle;
    const productPrice = addButton.dataset.productPrice;
    const productImage = addButton.dataset.productImage;
    const productDescription = addButton.dataset.productDescription;
    const variantTitle = addButton.dataset.variantTitle || '';
    
    // Update modal content
    this.productModalImage.src = productImage;
    this.productModalImage.alt = productTitle;
    this.productModalTitle.textContent = productTitle;
    this.productModalVariant.textContent = variantTitle;
    this.productModalDescription.textContent = productDescription || '';
    
    // Format and display price
    const price = parseFloat(productPrice);
    const discount = this.getCurrentDiscount();
    const discountedPrice = this.getDiscountedPrice(price);
    
    if (discount > 0) {
      this.productModalPrice.innerHTML = `
        <span class="bundle-product-modal__original-price">${this.formatMoney(price)}</span>
        <span class="bundle-product-modal__discounted-price">${this.formatMoney(discountedPrice)}</span>
        <span class="bundle-product-modal__discount-tag">${this.getDiscountPercentText()}</span>
      `;
    } else {
      this.productModalPrice.textContent = this.formatMoney(price);
    }

    // Update Add to Bundle button
    if (this.productModalAddBtn) {
      // Store all product data in the modal button
      this.productModalAddBtn.dataset.productId = productId;
      this.productModalAddBtn.dataset.productTitle = productTitle;
      this.productModalAddBtn.dataset.productPrice = productPrice;
      this.productModalAddBtn.dataset.productImage = productImage;
      this.productModalAddBtn.dataset.variantTitle = variantTitle;
      this.productModalAddBtn.dataset.productDescription = productDescription;

      // Check if product is already in bundle
      const existingItem = this.bundleItems.find(item => item.id === productId);
      if (existingItem) {
        this.productModalAddBtn.classList.add('in-bundle');
        this.productModalAddBtn.textContent = `AGGIUNGI (${existingItem.quantity})`;
      } else {
        this.productModalAddBtn.classList.remove('in-bundle');
        this.productModalAddBtn.textContent = this.translations.addToBundle;
      }
    }
    
    // Show modal
    this.productModal.classList.add('is-active');
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  }

  closeProductModal() {
    if (!this.productModal) return;
    
    this.productModal.classList.remove('is-active');
    document.body.style.overflow = ''; // Restore background scrolling
  }
}

// Initialize the bundle builder when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new BundleBuilder();
}); 